var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// Imports
import Vue from "vue";
import Component from "vue-class-component";
import { Clubs } from "../../../modules/clubs";
import moment from "moment";
// Define vue parameters
var ListClubsComponent = /** @class */ (function (_super) {
    __extends(ListClubsComponent, _super);
    /**
     * Setup the child and parent class
     */
    function ListClubsComponent() {
        var _this = _super.call(this) || this;
        // Create a clubs instance
        _this.clubs = new Clubs();
        return _this;
    }
    ListClubsComponent.prototype.formatDate = function (date) {
        return moment(date).format("M/D/YY");
    };
    /**
     * Component setup on mount
     */
    ListClubsComponent.prototype.mounted = function () {
        var _this = this;
        if (this.$props.playerId === 'me') {
            this.$data.showEdit = true;
        }
        // Get the players clubs
        this.clubs
            .clubShots(this.$props.playerId, this.$props.clubId, 1, 20)
            .then(function (r) {
            _this.$data.clubShots = r;
        })
            .then(function () {
            _this.clubs
                .getSpecific(_this.$props.playerId, _this.$props.clubId)
                .then(function (rr) {
                _this.$data.clubInfo = rr;
                _this.$data.loading = false;
            });
        });
    };
    ListClubsComponent.prototype.editClubModal = function () {
        this.$modal.show("edit-club");
    };
    /**
     * Add one to list
     */
    ListClubsComponent.prototype.showMore = function (moreAmount) {
        var _this = this;
        if (moreAmount === void 0) { moreAmount = 10; }
        if (this.$data.showMoreIsProcessing) {
            return;
        }
        this.$data.showMoreIsProcessing = true;
        this.$data.showMoreButtonClass = "show-more--processing";
        // The offset is used to paginate through entries
        var offset = this.$data.clubShots.clubShots.length + 1;
        // Append new entries to handicap data with offset from index
        this.clubs
            .clubShots(this.$props.playerId, this.$props.clubId, offset, this.$data.clubShots.to + moreAmount)
            .then(function (r) {
            _this.$data.clubShots.clubShots = _this.$data.clubShots.clubShots.concat(r.clubShots);
            // Update metadata
            _this.$data.clubShots.from = r.from;
            _this.$data.clubShots.to = r.to;
            _this.$data.showMoreIsProcessing = false;
            _this.$data.showMoreButtonClass = "show-more--default";
        });
    };
    ListClubsComponent = __decorate([
        Component({
            props: ["clubId", "playerId"],
            data: function () {
                return {
                    clubShots: null,
                    clubInfo: null,
                    loading: true,
                    showMoreIsProcessing: false,
                    showMoreButtonClass: "show-more--default",
                    showEdit: false,
                };
            }
        })
        // UPDATE
        // TO
        // THIS
        // https://api.swingbyswing.com/v1/reference/1054002532
        // Define the component code
    ], ListClubsComponent);
    return ListClubsComponent;
}(Vue));
export default ListClubsComponent;
